// The canonical developer/API documentation URL. /for-agents renders the same
// page and points its canonical here.

import { ogImageMeta } from "@/lib/og-images";
import { createFileRoute } from "@tanstack/react-router";
import { AgentDocs } from "@/components/agent-docs";
import { SITE } from "@/lib/site-content";

const TITLE = "Developer docs · Public API, MCP server & markdown | Vibing Company";
const DESC =
  "Developer documentation for vibing.inc: an unauthenticated JSON API over 2,000+ curated vibe-coding resources, a public MCP server, markdown twins of every page and OpenAPI 3.1.";

export const Route = createFileRoute("/docs")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: "Developer docs — the Vibing Company API & MCP" },
      ...ogImageMeta("for-agents", "Share card: developer docs"),
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://vibing.inc/docs" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: "https://vibing.inc/docs" },
      { rel: "alternate", type: "text/plain", href: "https://vibing.inc/llms.txt" },
      { rel: "alternate", type: "text/markdown", href: "https://vibing.inc/md/docs" },
      {
        rel: "service-desc",
        type: "application/json",
        href: "https://vibing.inc/api/public/openapi.json",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "TechArticle",
              "@id": "https://vibing.inc/docs#article",
              headline: "the Vibing Company developer documentation",
              description: DESC,
              url: "https://vibing.inc/docs",
              author: { "@type": "Organization", name: SITE.name, url: SITE.url },
            },
            {
              "@type": "WebAPI",
              "@id": "https://vibing.inc/#api",
              name: "the Vibing Company public API",
              description: DESC,
              documentation: "https://vibing.inc/docs",
              termsOfService: "https://vibing.inc/terms",
              provider: { "@type": "Organization", name: SITE.name, url: SITE.url },
              url: "https://vibing.inc/api/public/openapi.json",
            },
          ],
        }),
      },
    ],
  }),
  component: () => <AgentDocs headingId="docs-h" />,
});
